<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex lg12">
        <sp-360-panel :title="'management.users.manage-users' | translate">
          <div data-vv-scope="formUsuario">
            <div class="row">
              <div class="flex lg12" style="margin-top:56px;">
                <div class="row">
                  <div class="flex lg12" title="Consultar LDAP">
                    <va-button icon="fa fa-search cor1" type="va-button" @click="buscarUsuarioPorEmail()" class="btn btn-primary btn-sm pull-right">
                    </va-button>
                  </div>
                </div>
                <va-modal ref="buscarUsuarioLdapModal"
                   :okText="'management.consultar' | translate"
                   :cancelText="'management.cancel' | translate"
                   :okClass="'btn btn-primary btn-sm'"
                   :cancelClass="'btn btn-secondary btn-sm'"
                   @ok="buscarUsuarioLdap()"
                   @cancel="limparBuscaUsuarioLdap()"
                   :title="'management.users.consultar-ldap' | translate"
                   v-model="openModalBuscaLdap"
                   size="large"
                   maxWidth="100rem"
                   :fixedLayout="false"
                   >
                    <template slot="default">
                      <div data-vv-scope="formBusca" class="modalForm">
                        <fieldset>
                          <div class="input-group flex lg12 md12 sm12" style="width: 25rem">
                            <va-input ref="inputEmailBusca" id="emailBusca" name="email" @keyup.enter="buscarUsuarioLdap()" required v-model="emailBusca" label="Consultar usuário por email/local-part" placeholder="Digite email/local-part para pesquisar..."/>
                          </div>
                        </fieldset>
                      </div>
                    </template>
                </va-modal>
                <fieldset>
                  <div class="form-group" :class="{ 'has-error': errors.has('formUsuario.nome') }">
                    <div class="input-group">
                      <va-input id="nome" name="nome" required v-model="usuario.nome" v-validate="'required'" label="Nome"/>
                      <!-- 'management.users.name' -->
                    </div>
                  </div>
                  <div class="form-group with-icon-right"
                       :class="{'has-error': errors.has('formUsuario.email'), 'valid': isEmailValid}">
                    <div class="input-group">
                      <va-input
                        id="email"
                        name="email"
                        v-model="usuario.email"
                        v-validate="'required|email'"
                        required label="email"/>
                      <!-- 'management.users.email' -->
                    </div>
                  </div>
                  <div class="form-group with-icon-right"
                       :class="{'has-error': errors.has('formUsuario.rf')}">
                    <div class="input-group">
                      <va-input
                        id="rf"
                        name="rf"
                        v-model="usuario.username"
                        v-validate="{ required: true, regex:/^[dx]{1}[0-9]{6}$/ }"
                        required label="Registro Funcional"/>
                      <!-- 'management.users.functional-Registry' -->
                    </div>
                  </div>
                  <div class="form-group"  :class="{'has-error': errors.has('formUsuario.perfis')}">
                    <div class="input-group">
                      <multiselect
                        id="perfis"
                        name="perfis"
                        v-validate="'required'"
                        :placeholder="'management.users.profiles' | translate"
                        :options="options.perfis"
                        label="nome"
                        track-by="nome"
                        v-model="usuario.listaPerfil"
                        :multiple="true"
                        :close-on-select="false"
                      />
                      <small v-show="errors.has('formUsuario.perfis')"
                              class="help text-danger">{{
                          errors.first('formUsuario.perfis')
                          }}
                        </small>
                    </div>
                  </div>
                  <div class="form-group"  :class="{'has-error': errors.has('formUsuario.unidade')}">
                    <div class="input-group">

                    <multiselect
                      id="unidade"
                      name="unidade"
                      v-validate="'required'"
                      :placeholder="'management.users.unit' | translate"
                      :options="options.unidades"
                      :searchable="false"
                      label="nome"
                      track-by="nome"
                      v-model="usuario.unidade"
                    />

                    <small v-show="errors.has('formUsuario.unidade')"
                             class="help text-danger">{{
                        errors.first('formUsuario.unidade')
                        }}
                      </small>
                    </div>
                  </div>
                  <div class="row">
                    <div class="flex lg6">
                      <va-button type="va-button" @click="limpar()" class="btn btn-primary btn-sm pull-left">
                        {{'management.clear'| translate}}
                      </va-button>
                    </div>
                    <div class="flex lg6">
                      <va-button type="va-button" @click="persiste()" class="btn btn-primary btn-sm pull-right">
                        {{'management.save'| translate}}
                      </va-button>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div class="flex lg12">
                
                    <va-input class="filter-input"
                      v-model="termo"
                      placeholder="Pesquisar"
                      removable
                      @input="pesquisa"
                    >
                      <va-icon name="fa fa-search" slot="prepend" />
                  </va-input>
                  <sp360-dataTable id="tabelaUsuarios" ref="tabelaUsuarios"
                    :apiMode="false"
                    :data="dadosUsuariosFiltrados.data"
                    :fields="tableFields"
                    :dataModeFilterableFields="dataModeFilterableFields"
                    :sortFunctions="sortFunctions"
                    :perPage="itemsPerPage"
                    :filterInputShown="true"
                    @editarRow="editar($event)"
                    @ativarRow="ativar($event)"
                    @desativarRow="desativar($event)"
                  />
              </div>
            </div>
          </div>
        </sp-360-panel>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import UsuarioService from '@/services/UsuarioService'
import constantes from '@/utils/ConstantesGlobais'
import _ from 'lodash'
import MetodosGlobais from '@/utils/MetodosGlobais'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  components: { Multiselect, 'sp360-dataTable': Sp360DataTable, Sp360Panel },
  name: 'usuario',
  computed: {

  },
  beforeCreate () {
    Promise.all([
      this.$store.dispatch('perfil/getAllPerfil'),
      this.$store.dispatch('unidade/getAllUnidade'),
      this.$store.dispatch('usuario/getAllUsuario')
    ]).then( retorno =>{
      this.options.perfis = _.sortBy(retorno[0].data, 'nome')
      this.options.unidades = _.sortBy(retorno[1].data, 'nome')
      this.dadosUsuarios.data = retorno[2].data
      this.dadosUsuarios.data.forEach(usuario => {
        usuario['unidade_nome'] = usuario.unidade.nome
        usuario['unidade_sigla'] = usuario.unidade.sigla
      })
      this.dadosUsuariosFiltrados.data = retorno[2].data
      this.updateTabelaUsuarios(this.dadosUsuarios)
    })
  },
  data () {
    return {
      termo: null,
      usuario: UsuarioService.newUsuario(),
      options: {
        perfis: [],
        unidades: [],
      },
      emailBusca: '',
      openModalBuscaLdap: false,
      isEmailValid: false,
      dadosUsuarios: {
        'data': [],
      },
      dadosUsuariosFiltrados: {
        'data': [],
      },
      itemsPerPage: constantes.TAMANHO_TABELAS,
      tableFields: [
        {
          name: 'id',
          sortField: 'id',
          title: this.$t('management.users.id'),
          width: '5%',
        },
        {
          name: 'nome',
          sortField: 'nome',
          title: this.$t('management.users.name'),
        },
        {
          name: 'username',
          sortField: 'username',
          title: this.$t('management.users.rf'),
        },
        {
          name: 'unidade.nome',
          sortField: 'unidade.nome',
          title: this.$t('management.users.unit'),
        },
        {
          name: '__slot:edicao',
          dataClass: 'action-slot',
        },
        {
          name: '__slot:ativacao',
          dataClass: 'action-slot',
        },
      ],
      dataModeFilterableFields: ['nome', 'username', 'unidade'],
      sortFunctions: {
        'id': MetodosGlobais.ordenaTabela,
        'nome': MetodosGlobais.ordenaTabela,
        'username': MetodosGlobais.ordenaTabela,
        'unidade.nome': MetodosGlobais.ordenaTabela,
      },
    }
  },
  methods: {
    pesquisa: _.debounce(function (term) {
      this.termo = term
      let filtroUsuarios = []

      if((!Number.isNaN(parseInt(term))) && term !="" ){
        filtroUsuarios = this.$refs.tabelaUsuarios.filterByNumber(this.dadosUsuarios.data, this.termo)
      }else{
        filtroUsuarios = this.$refs.tabelaUsuarios.filterByString(this.dadosUsuarios.data, this.termo)
      }
      
      this.dadosUsuariosFiltrados.data = filtroUsuarios
      this.updateTabelaUsuarios(this.dadosUsuariosFiltrados)
    }, 400),

    buscarUsuarioPorEmail () {
      this.limpar()
      this.openModalBuscaLdap = !this.openModalBuscaLdap
      this.$nextTick(function () {
        this.$refs.inputEmailBusca.$children[0].$slots.default[0].children[0].children[1].elm.focus()
      })
    },
    buscarUsuarioLdap() {
      this.openModalBuscaLdap = false
      let email = this.emailBusca
      if(!this.emailBusca.includes("@")) {
        this.emailBusca = this.emailBusca + "@prefeitura.sp.gov.br"
      }
      this.$store.dispatch('usuario/buscarUsuarioLdapPorEmail', this.emailBusca)
        .then(retorno => {
            this.usuario.nome = retorno.data.nome
            this.usuario.email = retorno.data.email
            this.usuario.username = retorno.data.username
            this.usuario.unidade = this.buscaUnidadeOuNulo(retorno.data.unidade)
            this.usuario.listaPerfil.push(this.options.perfis.find(el => el.nome === "GERAL"))
          })
          .catch(err => {
            console.error(err)
            this.showToast(this.$t('management.users.erro-busca-ldap', {email: email}), constantes.TOASTED_ERROR)
          })
      this.emailBusca = ''
    },
    buscaUnidadeOuNulo(unidade) {
      const partesUnidade = unidade.split("-")
      var busca = null
      partesUnidade.some(parte => {
        busca = this.options.unidades.find(el => el.sigla.trim().toUpperCase() === parte.trim().toUpperCase())
        if(busca) return true
        else busca = null
      })
      return busca
    },
    limparBuscaUsuarioLdap() {
      this.emailBusca = ''
      this.limpar()
    },
    ordenaTabela (item1, item2) {
      return item1 >= item2 ? 1 : -1
    },
    editar (event) {
      this.usuario = _.clone(event.rowData)
    },
    ativar (event) {
      this.$store.dispatch('usuario/ativarUsuario', event.rowData.id)
        .then(retorno => {
          event.rowData.ativo = true
          this.showToast(this.$t('management.users.usuario') + ` ${event.rowData.nome}` + this.$t('management.activated'), constantes.TOASTED_SUCCESS)
        })
        .catch(err => {
          console.error(err)
          this.showToast(this.$t('management.activatedError'), constantes.TOASTED_ERROR)
        })
    },
    desativar (event) {
      this.$store.dispatch('usuario/desativarUsuario', event.rowData.id)
        .then(retorno => {
          event.rowData.ativo = false
          this.showToast(this.$t('management.users.usuario') + ` ${event.rowData.nome}` + this.$t('management.disabled'), constantes.TOASTED_SUCCESS)
        })
        .catch(err => {
          console.error(err)
          this.showToast(this.$t('management.disabledError'), constantes.TOASTED_ERROR)
        })
    },
    valida () {
      return this.$validator.validateAll('formUsuario').then(valid => {
        return valid
      })
    },
    persiste (usuario) {
      event.preventDefault()
      this.valida().then(valido => {
        if (!valido) {
          this.showToast(this.$t('management.incorrectFields'), constantes.TOASTED_ERROR)
        } else {
          if (this.usuario.id == 0) {
            this.$store.dispatch('usuario/postUsuarioRetornar', this.usuario).then(
              retorno => {
                this.showToast(this.$t('management.users.usuario') + ` ${retorno.data.nome}` + this.$t('management.inserted'), constantes.TOASTED_SUCCESS)
                this.dadosUsuarios.data.push(retorno.data)
                this.usuario = UsuarioService.newUsuario()
                // this.$refs.tabelaUsuarios.update()
                this.$validator.reset()
              }
            )
              .catch(err => {
                console.error(err)
                this.showToast(this.$t('management.insertedError'), constantes.TOASTED_ERROR)
              })
          } else {
            let index = _.findIndex(this.dadosUsuarios.data, user => user.id == this.usuario.id)

            this.$store.dispatch('usuario/putUsuario', this.usuario).then(
              retorno => {
                this.updateUsuario(this.usuario, index)
                this.showToast(this.$t('management.users.usuario') + ` ${this.usuario.nome}` + this.$t('management.updated'), constantes.TOASTED_SUCCESS)
                this.limpar()
              })
              .catch(err => {
                console.error(err)
                this.showToast(this.$t('management.updatedError'), constantes.TOASTED_ERROR)
              })
          }
        }
      })
    },
    updateUsuario (usuario, index) {
      this.$refs.tabelaUsuarios.resetPage()
      Vue.set(this.dadosUsuarios.data, index, usuario)
    },
    atualiza (usuario) {
    },
    limpar () {
      if (event) event.preventDefault()
      this.usuario = UsuarioService.newUsuario()
      this.$validator.reset()
    },
    updateTabelaUsuarios(dados){
      this.$set(this.dadosUsuariosFiltrados, 'data', dados.data)
    }
  },
}
</script>

<style lang="scss">
  //@import "../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css";
  .multiselect__placeholder {
    color: $brand-success;
  }

</style>
